import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("jkj_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setToken = (t) => localStorage.setItem("jkj_token", t);
export const clearToken = () => localStorage.removeItem("jkj_token");
export const getToken = () => localStorage.getItem("jkj_token");

export function mediaUrl(u) {
  if (!u) return u;
  if (u.startsWith("http")) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u}`;
}

// Forgive common paste mistakes in CMS link fields:
// trims spaces, fixes "#https://..." and converts full URLs of this site to relative paths.
export function normalizeHref(u) {
  if (!u) return u;
  let v = String(u).trim();
  if (/^#https?:\/\//i.test(v)) v = v.slice(1);
  const ownHosts = [window.location.origin, process.env.REACT_APP_BACKEND_URL].filter(Boolean);
  for (const o of ownHosts) {
    if (v.toLowerCase().startsWith(o.toLowerCase())) { v = v.slice(o.length) || "/"; break; }
  }
  return v;
}
